import { render } from "./LargeNavigationButtonsSection.vue?vue&type=template&id=472b74a4&scoped=true"
import script from "./LargeNavigationButtonsSection.vue?vue&type=script&lang=js"
export * from "./LargeNavigationButtonsSection.vue?vue&type=script&lang=js"

import "./LargeNavigationButtonsSection.vue?vue&type=style&index=0&id=472b74a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-472b74a4"]])

export default __exports__